import axios from "axios";
import router from "../router";
import message from "ant-design-vue/lib/message";
import { SYSTEM_RECEIPT } from "@/config/constant";

const config = {
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 30 * 1000,
  withCredentials: true,
};

class HttpRequest {
  service = null;
  constructor(config) {
    this.service = axios.create(config);

    // 请求拦截器
    this.service.interceptors.request.use(
      (config) => {
        // 配置跨域
        config.crossDomain = true;
        config.withCredentials = false;
        // 禁用服务器缓存
        if (config.method.toUpperCase() === "GET") {
          config.params = {
            ...config.params,
            ...{ _t: new Date().getTime() },
          };
        }

        // 添加token
        if (config.headers && typeof config.headers.set === "function") {
          config.headers.set(
            "Authorization",
            `Bearer ${sessionStorage.getItem("accessToken")}`
          );
          config.headers.set(
            "secret",
            "6aae5ea9abd6a86df1556ff851d09ff7255670a8a5da822e446cad459d9203e4"
          );
          config.headers.set("AdminPanel", "AdminPanel");
        }

        return config;
      },
      (err) => {
        return Promise.reject(err);
      }
    );

    // 响应拦截器
    this.service.interceptors.response.use(
      (response) => {
        const { data, config } = response;
        if (data.code && data.code != 200) {
          if (data.code === 401) {
            message.open({
              type: "error",
              duration: 2,
              maxCount: 3,
              content: data.message,
            });
          }
          if (data.code === 500) {
            message.open({
              type: "error",
              duration: 2,
              maxCount: 3,
              content: data.message,
            });
          }
        }
        return data;
      },
      async (err) => {
        // 请求超时 && 网络错误单独判断，没有 response
        if (err.message.indexOf("timeout") !== -1) {
          console.log("请求超时！请稍后重试");
        }
        if (err.message.indexOf("Network Error") !== -1) {
          console.log("网络错误！请您稍后重试");
        }

        // 服务器结果都没有返回(可能服务器错误可能客户端断网)，断网处理:可以跳转到断网页面
        if (!window.navigator.onLine) {
          console.log("网络错误！请您稍后重试");
        }
        return Promise.reject(err);
      }
    );
  }
}
export default new HttpRequest(config);
